<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
      <v-select
        :items="subjects"
        v-model="filters.subjectId"
        item-text="name"
        item-value="id"
        :label="$t('fields.subject')"
        :error-messages="errors"
      >
      </v-select>
      </v-flex>
      <v-flex xs3 class="mr-2">
      <v-select
        :items="propagandists"
        v-model="filters.propagandistId"
        item-text="fullname"
        item-value="id"
        :label="$t('fields.propagandist')"
        :error-messages="errors"
        multiple
      >
      </v-select>
      </v-flex>
      <v-flex xs3 class="mr-2">
      <SchoolTypeSelect
        :errors="errors"
        v-model="filters.schoolTypeId"
        :clearable="true"
      >

      </SchoolTypeSelect>
      </v-flex>
      <v-flex xs2 class="mr-2">

      <v-select
        :items="schoolTypesMain"
        v-model="filters.schoolTypeMainId"
        item-text="name"
        item-value="id"
        :label="$t('fields.school_orders')"
        :error-messages="errors"
        multiple
      >
      </v-select>
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-flex xs3 class="mr-2">
        <AutoComplete
          v-model="searchSchool"
          :value="searchSchool"
          key-value="id"
          key-name="fullname"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="schools"
          :label="$t('fields.school')"
          @search="searchSchools"
          @input="fetchSchoolsIfExist"
          @clear="deleteSelectedSchools"
          :delay="2000"
          :disabled="loading"
        >
        </AutoComplete>
      </v-flex>
      <v-flex xs2 class="mr-2">
        <v-switch
          v-model="filters.withEmail"
          :label="$t('ONLY_TEACHERS_WITH_EMAIL')"
        ></v-switch>
      </v-flex>
        <v-spacer></v-spacer>
          <v-btn
            v-if="currentUser.user.is_propagandist"
            class="primary mb-2 mr-2"
            :disabled="!teacherSelected.length"
            @click="showCampaignMassiveModal()"
          >
          {{ $t('NEW_ESSAY')}}
          </v-btn>
          <!-- Email solo a docenti con email valida: serve il filtro "Solo docenti con email" -->
          <v-tooltip bottom :disabled="filters.withEmail">
            <template v-slot:activator="{ on, attrs }">
              <!-- span: un v-btn disattivato non riceve gli eventi del tooltip -->
              <span v-bind="attrs" v-on="on">
                <v-btn
                  class="mb-2 default"
                  @click="showEmailModal()"
                  :disabled="!filters.withEmail || !teacherSelected.length"
                >
                {{ $t('EMAIL') }}
                </v-btn>
              </span>
            </template>
            <span>{{ $t('EMAIL_NEEDS_WITH_EMAIL_FILTER') }}</span>
          </v-tooltip>
    </v-row>
    </v-container>
    <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="totalItems"
            :no-data-text="$t('NO_DATA')"
            :no-results-text="$t('NO_DATA')"
            hide-default-footer
            :options.sync="pagination"
            :loading="loading"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            show-select
            v-model="teacherSelected"
            class="elevation-1"
            :item-class="itemRowBackground"
    >
            <template v-slot:[`item.teacher_fullname`]="{ item }">
                  {{ item.teacher.fullname }}
            </template>

            <template v-slot:[`item.school_name`]="{ item }">
                <span v-if="item.school.locations.options.branch_code">
                  {{ item.school.locations.options.branch_code }}
                </span>
                {{ item.school.name }}
            </template>

            <template v-slot:[`item.phone`]="{ item }">
                {{ item.teacher.address.phone }}
            </template>

            <template v-slot:[`item.email`]="{ item }">
                <a :mailto="item.teacher.address.email">{{ item.teacher.address.email }}</a>
            </template>

            <template v-slot:[`item.address`]="{ item }">
                {{ item.teacher.address.street }}
            </template>

            <template v-slot:[`item.city`]="{ item }">
                {{ item.teacher.address.city }}
            </template>

            <template v-slot:[`item.subject_name`]="{ item }">
                {{ item.subject.name }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                  <v-layout row wrap>
                    <v-flex>
                        <v-btn
                          icon
                          :color="item.school.counter > 1 ? 'white' : 'blue'"
                          v-if="can('edit teachers')"
                          :disabled="!currentUser.user.is_propagandist"
                          @click="showCampaignModal(item.teacher.id)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                    </v-flex>
                  </v-layout>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <campaign-teacher-detail-table
                  :teacher-id="item.teacher.id"
                >
                </campaign-teacher-detail-table>
              </td>
            </template>
          </v-data-table>
          <Paginator
            :total-items="totalItems"
            :page.sync="pagination.page"
            :items-per-page.sync="pagination.itemsPerPage"
            :per-page-options="[10, 20, 40, 60, 100, 150, 200]"
            @change="fetchTeachers"
          />
  </div>
  </v-flex>
</template>
<script>

  import { mapActions, mapGetters } from 'vuex';

  import { campaignsService } from '../../utils/services/campaigns.service';
  import { subjectsService } from '../../utils/services/subjects.service';
  import { communicationsService } from '../../utils/services/communications.service';
  import { propagandistsService } from '../../utils/services/propagandists.service';
  import { schoolsService } from '../../utils/services/schools.service';


  import CampaignTeacherModal from '../../components/modals/Campaigns/CampaignTeacherModal';
  import CampaignTeacherSubjectModal from '../../components/modals/Campaigns/CampaignTeacherSubjectModal';
  import CommunicationModal from '../../components/modals/Communications/CommunicationModal.vue';
  import CampaignTeacherDetailTable from '../../components/app/Campaigns/CampaignTeacherDetailTable';
  import SchoolTypeSelect from '../../components/shared/Vselects/SchoolTypeSelect.vue';
  import AutoComplete from '../../components/shared/Inputs/AutoComplete';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'CampaignSubject',
    components: {
      CampaignTeacherDetailTable,
      SchoolTypeSelect,
      AutoComplete,
      Paginator,
    },
    data() {
      return {
        loading: false,
        expanded: [],
        singleExpand: true,
        schoolTypesMain: [
          { id: 'SS1G', name: 'SS1G' },
          { id: 'SS2G', name: 'SS2G' },
        ],

        items: [],
        subjects: [],
        propagandists: [],
        teacherSelected: [],
        schoolTypes: [],
        schools: [],
        searchSchool: null,
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['teacher_fullname'],
        },
        headers: [
          { text: this.$t('fields.teacher'), value: 'teacher_fullname' },
          { text: this.$t('fields.school'), value: 'school_name' },
          { text: this.$t('fields.subject'), value: 'subject_name', sortable: false },
          { text: this.$t('fields.phone'), value: 'phone', sortable: false },
          { text: this.$t('fields.email'), value: 'email', sortable: false },
          { text: this.$t('fields.address'), value: 'address', sortable: false },
          { text: this.$t('fields.city'), value: 'city', sortable: false },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
          { text: '', value: 'data-table-expand' },
        ],
        filters: {
          subjectId: 0,
          schoolTypeId: [],
          propagandistId: [],
          schoolTypeMainId: [],
          searchSchools: null,
          withEmail: false,
          schoolId: 0,
        },
      };
    },
    computed: {
      ...mapGetters('user', ['currentUser']),
      requestFilters() {
        const filters = {
          subjectId: this.filters.subjectId,
          schoolTypeId: this.filters.schoolTypeId,
          propagandistId: this.filters.propagandistId,
          schoolTypeMainId: this.filters.schoolTypeMainId,
          schoolId: this.filters.schoolId,
          withEmail: this.filters.withEmail ? 1 : undefined,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      itemRowBackground(item) {
        return item.school.counter > 1 ? 'blue' : '';
      },
      async showCampaignModal(id) {
        this.showModal({
          component: CampaignTeacherModal,
            data: {
              stored: {
                id,
                teacher_id: this.filters.teacherId || id,
              },
          },
          options: {
            title: this.$t('CAMPAIGN'),
            fullscreen: true,
            onSave: (
              form,
              error,
            ) => campaignsService.save(form)
            .then(() => {
              this.hideModal({});
              this.fetchTeachers();
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            }),
          },
        });
      },

      async showEmailModal() {
        this.showModal({
          component: CommunicationModal,
            data: {
              stored: {
                emails: this.teacherSelected.map(x => x.teacher.address.email),
              },
          },
          options: {
            title: this.$t('EMAIL'),
            fullscreen: false,
            onSave: (
              form,
              error,
            ) => communicationsService.sendEmail(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SENT') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            }),
          },
        });
      },

      async showCampaignMassiveModal() {
        const teachers = this.teacherSelected.map(x => x.id);
        this.teacherSelected = [];
        this.showModal({
          component: CampaignTeacherSubjectModal,
            data: {
              stored: {
                teachers,
              },
          },
          options: {
            title: this.$t('CAMPAIGN'),
            fullscreen: true,
            onSave: (
              form,
              error,
            ) => campaignsService.save(form)
            .then(() => {
              this.hideModal({});
              this.fetchTeachers();
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            }),
          },
        });
      },

      fetchSubjects() {
        return subjectsService.index({
          filters: {
            sortBy: ['name'],
            sortDesc: [false],
          },
          itemsPerPage: 500,
        })
        .then(response => {
            this.subjects = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      fetchPropagandist() {
        return propagandistsService.index({
          filters: {
            sortBy: ['surname'],
            sortDesc: [false],
          },
        })
        .then(response => {
            this.propagandists = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchTeachers(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return subjectsService.teachers(this.filters.subjectId, {
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async searchSchools(val) {
        this.filters.searchSchools = val;
        await this.fetchSchools();
      },

      async fetchSchools() {
        this.loading = true;
        return schoolsService.index({
          filters: {
            search: this.filters.searchSchools,
          },
        })
        .then(response => {
            this.resetItems();
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      resetItems() {
        this.totalItems = 0;
        this.items = [];
      },

      deleteSelectedSchools() {
        this.resetItems();
        this.school = {};
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
          await this.fetchSchool(id);
        } else {
          this.filters.schoolId = 0;
        }
      },

      fetchSchool(id) {
        this.loading = true;
        return schoolsService.get(id)
        .then(response => {
            this.school = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },
    },
    async created() {
      this.fetchSubjects();
      this.fetchPropagandist();
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.teacherSelected = [];
          this.fetchTeachers(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchTeachers(1);
          }
        },
      },
    },
  };
</script>
